/**
 * Returns the design settings carried by a saved QR Code template, whatever
 * shape the API delivered it in.
 *
 * Core's DTO migration (core `a3beb90`, on dev since 2026-09-03) flattened
 * `GET /qrcodes/templates`: `template.design` *is* the settings object now,
 * where it used to be the design row wrapping it (`template.design.design`).
 * Prod still serves the wrapped shape until that core commit ships, so both
 * are accepted. Returns `null` when neither shape carries a design.
 */
export function getTemplateDesign(template: any): any | null {
    const design = template?.design
    if (!design || typeof design !== "object") return null
    // Legacy wrapped shape: { design: { design: {...settings} } }
    if (design.design && typeof design.design === "object") return design.design
    // Flat DTO shape: { design: {...settings} } — a settings object always
    // carries a layout block, which the legacy wrapper never did.
    if ("layout" in design || "eyes" in design || "modules" in design) return design
    return null
}
